module.exports = __webpack_public_path__ + "img/hc_pro_two_4.1a536ef9.jpg";